import { useCallback } from "react";
import {
  usePersonNotesQuery,
  useUpsertPersonNoteMutation,
} from "@/features/people/graphql/generated";

type UpsertTeamNoteInput = {
  note: string;
  type: string;
  personId?: number;
  id?: number;
};

export const usePersonNotes = (personId: number) => {
  const { data, loading, error } = usePersonNotesQuery({
    variables: {
      filter: {
        person_id: personId || null,
      },
    },
  });

  const notes = data?.personNotes;

  const [upsertPersonNote] = useUpsertPersonNoteMutation();
  // const [deleteTeamNote,] = useDeleteTeamNoteMutation();

  const handleUpsertPersonNote = useCallback(
    (input: UpsertTeamNoteInput) => {
      upsertPersonNote({
        variables: {
          personId: input.personId || personId,
          note: input.note,
          type: input.type,
          id: input.id || null,
        },
      });
    },
    [personId]
  );

  const handleDeletePersonNote = useCallback(
    (id: number, type: string) => {
      handleUpsertPersonNote({
        note: "",
        type,
        id,
      });
    },
    [handleUpsertPersonNote]
  );

  return {
    notes,
    loading,
    error,
    handleUpsertPersonNote,
    handleDeletePersonNote,
  };
};
